import { Component, OnInit } from "@angular/core";
import { RadioButtonOption } from "../../../../../../common/models/flow.dto";
import { BaseControlComponent } from "../../../../../../form-controls/components/base-control/base-control.component";
import { ContextInteractionService } from "../../../../../../form-controls/services/context-interaction.service";
import { applyFroalaAriaFix, stripFroalaWatermark } from '../../../../../../common/utils/froala.utils';

@Component({
    selector: "app-file-upload-display-config",
    templateUrl: "./file-upload-display-config.component.html",
    standalone: false
})
export class FileUploadDisplayConfigComponent extends BaseControlComponent implements OnInit {
    static componentName = "FileUploadDisplayConfigComponent";

    showChangeWarning: boolean = false;

    constructor(public readonly contextService: ContextInteractionService) { super(contextService); }

    private _froalaOptions: any = null;
    get froalaOptions(): any {
        if (!this._froalaOptions) {
            this._froalaOptions = applyFroalaAriaFix({
                heightMax: 300,
                heightMin: 150,
                key: this.editorKey,
                toolbarButtons: ["fullscreen", "html", "|", "undo", "redo", "|", "bold", "italic", "underline", 'strikeThrough', "|", "formatOL", "formatUL", "|", "align", "fontSize", "paragraphFormat", "insertLink", "|", "outdent", "indent", "clearFormatting", "insertTable", "color"]
            });
        }
        return this._froalaOptions;
    }

    standardOptions = [
        { id: "deliver", displayText: "Deliver Documents", included: true, displayOrder: 1, showsText: true, showsUpload: false, standardOption: true } as RadioButtonOption,
        { id: "upload", displayText: "Upload Files", included: true, displayOrder: 2, showsText: false, showsUpload: true, standardOption: true} as RadioButtonOption,
        { id: "notapplicable", displayText: "Not Applicable", included: true, displayOrder: 3, showsText: false, showsUpload: false, standardOption: true } as RadioButtonOption,
        { id: "nodocs", displayText: "No Documents", included: true, displayOrder: 4, showsText: false, showsUpload: false, standardOption: true } as RadioButtonOption
    ]

    ngOnInit() {
        if (!this.componentData.config) {
            this.componentData.config = {
                useRadioButtons: false,
                radioOptions: this.standardOptions,
                deliverText: "Address to Deliver Documents"
            }
        } else if (!this.componentData.config.radioOptions) {
            this.componentData.config.radioOptions = this.standardOptions;
            this.componentData.config.useRadioButtons = false;
        }
        if (!this.componentData.config.deliverText) {
            this.componentData.config.deliverText = "Address to Deliver Documents";
        }
        this.reorder();
    }

    onDeliverTextChange(): void {
        this.componentData.config.deliverText = stripFroalaWatermark(this.componentData.config.deliverText);
    }

    radioChanged(): void {
        this.showChangeWarning = true;
    }

    reorder(): void {
        this.componentData.config.radioOptions.sort((a, b) => this.sortOptions(a, b));
    }

    sortOptions(a: RadioButtonOption, b: RadioButtonOption) : number {
        return (a.displayOrder > b.displayOrder) ? 1 : -1;
    }

}


